import * as constants from '@/config/constants'
export function specialityType2CN(type) {
  return {
    '1': '理工',
    '2': '文史',
  }[type] || type
}

// 学校专业 院校层级转中文
export function collegeLevel2CN(value) {
  if (!value) return value
  let ids = value.split(',')
  // 院校层级
  return constants.schoolCollegeLevel.filter(item => ids.includes(item.value))
    .map(item => item.label).join('，')
}
